'use client';

import { useEffect, useState } from 'react';

/**
 * The viewer's clock in epoch ms, ticked every `intervalMs`. `null` until the
 * component has mounted (so the server render and the first client render
 * agree), and paused while the tab is hidden so a backgrounded page costs
 * nothing. Lifted from the Schedule grid's private clock so Matches shares it.
 */
export function useNowMs(intervalMs: number): number | null {
  const [now, setNow] = useState<number | null>(null);

  useEffect(() => {
    let id: ReturnType<typeof setInterval> | null = null;
    const tick = () => setNow(Date.now());
    const start = () => {
      if (id !== null) return;
      tick();
      id = setInterval(tick, intervalMs);
    };
    const stop = () => {
      if (id !== null) clearInterval(id);
      id = null;
    };
    const onVis = () => (document.hidden ? stop() : start());
    if (!document.hidden) start();
    document.addEventListener('visibilitychange', onVis);
    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [intervalMs]);

  return now;
}
